var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.changed),expression:"changed"}],ref:"autosizeTextarea",staticClass:"context-form",attrs:{"rows":"1"},domProps:{"value":(_vm.changed)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.changed=$event.target.value},_vm.handleChange]}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7238d59e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AutosizeTextarea.vue
// module id = 975
// module chunks = 1